/** Server-supplied reason for a rejected request, when it is a plain string. */
export function rejectionDetail(error: unknown): string | null {
  const detail = (error as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail;
  return typeof detail === 'string' ? detail : null;
}
